import { handleActions } from "redux-actions";

import { SYSTEM_TYPE } from "./types";

const initState = {
  systemType: null,
};

export default handleActions(
  {
    [SYSTEM_TYPE]: (state, { payload }) => {
      return { ...state, systemType: payload };
    },
  },
  initState
);
